import {AfterViewInit, Component, EventEmitter, HostBinding, Input, OnInit, Output} from '@angular/core';
import {GeneralService, SnackbarService} from '../../../core';
import {ActivatedRoute, Router} from '@angular/router';
import {BaseTable} from '../base-table';

@Component({
    selector: 'pr-new-local-table',
    templateUrl: './local-table.component.html',
    styleUrls: ['./local-table.component.scss', '../base-table.scss']
})
export class LocalTableComponent extends BaseTable implements OnInit, AfterViewInit {

    @HostBinding('class') classes = 'flex flex-grow';

    @Input() tableData: any[];
    @Input() isLoading = true;
    @Input() selectedOption = false;

    @Output()
    selectedRows = new EventEmitter();

    selected: any[] = [];

    selectedTable = {
        field: 'selectedTable',
        columnDef: 'selectedTable',
        header: 'Selected',
        showSort: false,
        showSearch: false,
        width: 5
    };

    constructor(
        private snackBar: SnackbarService,
        generalService: GeneralService,
        router: Router,
        activatedRoute: ActivatedRoute
    ) {
        super(router, generalService, activatedRoute);
    }

    ngOnInit(): void {
    }

    ngAfterViewInit(): void {
        this.setAllParameters();
        this.saveTableState();
    }

    clearGlobalFilter() {
        this.filterGlobalControl.reset();
        this.dt.filterGlobal(this.filterGlobalControl.value, 'contains');
    }

    onRowSelect(row: any) {
        this.selectedRows.emit(this.selected);
    }

    onRowUnselect(row: any) {
        this.selectedRows.emit(this.selected);
    }

    getSelectedColumns() {
        this.selectedRows.emit(this.selected);
        return [this.selectedTable, ...this.selectedColumnsControl.value];
    }
}
